/**
 * AudioStory domain enums
 */

export type AssemblyStatus = 'no_audio' | 'generating' | 'assembling' | 'ready' | 'error';

/** Source of an AudioBlock's audio (used within AudioStory domain) */
export type AudioBlockSource = 'ai' | 'recording';

export type AudioStoryStatus = 'draft' | 'ready' | 'error';

// ─── Audio enums (moved to shared/types/audio.ts to break circular dep) ─────


export enum AudioStatus {
  AudioCompleted = 'audio_completed',
  NoAudio = 'no_audio',
  PartialAudio = 'partial_audio',
}

export enum AudioJobStatus {
  Cancelled = 'cancelled',
  Completed = 'completed',
  Failed = 'failed',
  Pending = 'pending',
  Processing = 'processing',
}

export enum AudioJobType {
  Assembly = 'assembly',
  BlockGeneration = 'block_generation',
}
